module.exports = __webpack_public_path__ + "img/awg_logo.29728ad0.png";